"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EMPTY = "";
/**
 * Appends a segment to a path prefix.
 * @param {string | undefined} prefix - The prefix to append the segment to, or undefined if no prefix exists.
 * @param {string} segment - The segment to append to the prefix.
 * @returns {string} The concatenated path, with the segment appended to the prefix (if provided).
 */
var appendPath = function (prefix, segment) { return "".concat(prefix !== null && prefix !== void 0 ? prefix : EMPTY).concat(segment); };
exports.default = appendPath;
